import { render, staticRenderFns } from "./PhysicalChemicalTab.vue?vue&type=template&id=95f297ce&scoped=true&"
import script from "./PhysicalChemicalTab.vue?vue&type=script&lang=js&"
export * from "./PhysicalChemicalTab.vue?vue&type=script&lang=js&"
import style0 from "./PhysicalChemicalTab.vue?vue&type=style&index=0&id=95f297ce&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f297ce",
  null
  
)

export default component.exports